import { useLocalization } from '@microsoft/portal-app/lib/shared/localization';
import React from 'react';
import { Details } from '../../shared/Details';
import { CannotEditInfoDetailsContent } from './CannotEditInfoDetailsContent';

/**
 * Expandable component that explains why specific user info presented on person badge cannot be edited.
 */
export const CannotEditInfoDetails: React.FC = () => {
  const [t] = useLocalization('Account');

  return (
    <Details title={t('cantEdit')}>
      <CannotEditInfoDetailsContent />
    </Details>
  );
};
